import { configureStore, combineReducers } from "@reduxjs/toolkit";
import storage from 'redux-persist-indexeddb-storage';
import { persistStore, persistReducer} from 'redux-persist';
import authReducer from "./authSlice";
import modalReducer from './modalSlice';

const persistConfig = {
  key: 'root',
  storage: storage("jlrpt"),  
};

const rootReducer = combineReducers({
  auth: authReducer,
  modal: modalReducer,
});

const persistedReducer = persistReducer(persistConfig,rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware:(getDefaultMiddleware)=>
      getDefaultMiddleware({
          serializableCheck: {
          ignoredActions: ['persist/FLUSH', 'persist/REHYDRATE', 'persist/PAUSE', 'persist/PURGE', 'persist/REGISTER'],
      },
  }),
});

export const persistor = persistStore(store);
